import { useEffect, useState } from 'react';
import { buildApiUrl } from '../services/apiConfig';

const HEALTH_CHECK_INTERVAL_MS = 5000;
const HEALTH_CHECK_TIMEOUT_MS = 2500;

function useServerStatus() {
  const [isServerOnline, setIsServerOnline] = useState(null);

  useEffect(() => {
    let isMounted = true;
    let timeoutId;

    async function checkServerStatus() {
      if (typeof navigator !== 'undefined' && !navigator.onLine) {
        if (isMounted) {
          setIsServerOnline(false);
        }
        return;
      }

      const controller = new AbortController();
      const abortId = window.setTimeout(() => {
        controller.abort();
      }, HEALTH_CHECK_TIMEOUT_MS);

      try {
        const response = await fetch(buildApiUrl('/health'), {
          cache: 'no-store',
          signal: controller.signal,
        });

        if (isMounted) {
          setIsServerOnline(response.ok);
        }
      } catch (error) {
        if (isMounted) {
          setIsServerOnline(false);
        }
      } finally {
        window.clearTimeout(abortId);
      }
    }

    function scheduleNextCheck() {
      timeoutId = window.setTimeout(async () => {
        await checkServerStatus();
        scheduleNextCheck();
      }, HEALTH_CHECK_INTERVAL_MS);
    }

    checkServerStatus();
    scheduleNextCheck();
    window.addEventListener('online', checkServerStatus);
    window.addEventListener('focus', checkServerStatus);

    return () => {
      isMounted = false;
      window.clearTimeout(timeoutId);
      window.removeEventListener('online', checkServerStatus);
      window.removeEventListener('focus', checkServerStatus);
    };
  }, []);

  return isServerOnline;
}

export default useServerStatus;
